import { render, staticRenderFns } from "./deletiondialog.vue?vue&type=template&id=5206ae9c&"
import script from "./../../ts/dialog/deletiondialog.ts?vue&type=script&lang=js&"
export * from "./../../ts/dialog/deletiondialog.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports